// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"4e7a3e2a","293":"60ee13b5","316":"ad37691d","322":"387d532b","453":"3e52695d","504":"551d006e","633":"9f7e1145","650":"c8ca6c11","662":"e3c76dd2","836":"851f7eed","891":"bc778c9c","927":"660e47fd"}[chunkId] + ".chunk.js";
};